import { render, staticRenderFns } from "./machineSwitch.vue?vue&type=template&id=020e6516&scoped=true&"
import script from "./machineSwitch.vue?vue&type=script&lang=js&"
export * from "./machineSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020e6516",
  null
  
)

export default component.exports